import React from "react";

const JoinUs = () => {
  return (
    <div className="container my-5">
        <div className="heading">
        Join Us
      </div>
      <hr />
      <div>
        We are always interested in joining our group from motivated, qualified,
        and talented students wishing to accomplish their B. Tech project,
        Master's, Ph.D., or Postdoctoral research with us.
        <br />
        Ph.D. students are encouraged to contact Dr. Atanu K Metya to discuss
        possible research fields.
        <br />
        Funded postdoctoral research positions are not available at the moment.
        However, we are interested in accepting applicants who would like to
        apply for personal funding through various sources such as: National
        Postdoctoral Fellowship (NPDF) (
            <a className="remove-underline" href="https://serbonline.in/SERB/npdf" target={"_blank"}>link</a>)
      </div>
      <h4 className="mt-4 text-bold">OPENING: Junior Research Fellow(JRF) <a className="remove-underline" href="https://www.iitp.ac.in/index.php/2-uncategorised/1521-advertisement-no-r-d-711-serb-280-dated-10-05-2023-for-the-post-of-junior-research-fellow-jrf" target={"_blank"}>link</a> </h4> 
    </div>
  );
};

export default JoinUs;
